import { ALIASES_FOR_REGIONS, DEFAULT_LOCALE, ALL_REGIONS, ALL_LANGUAGES, DEFAULT_LANGUAGE_BY_REGION, LANGUAGE_DISPLAY_NAMES, DEFAULT_LANGUAGE, EU_REGIONS, ACTIVE_LOCALES, LOCALES_PER_REGION } from './locale_config.esm.js';

function getRegionForAlias(alias) {
    return ALIASES_FOR_REGIONS[alias];
}
function getLocale(regionInput, lang) {
    if (regionInput === undefined) {
        return DEFAULT_LOCALE;
    }
    var region = ALL_REGIONS.includes(regionInput) ? regionInput : getRegionForAlias(regionInput.toLowerCase());
    var isValidLang = lang != null && ALL_LANGUAGES.includes(lang);
    if (region !== undefined) {
        return "".concat(isValidLang ? lang.toLowerCase() : DEFAULT_LANGUAGE_BY_REGION[region], "-").concat(region.toUpperCase());
    }
    return DEFAULT_LOCALE;
}
function getDefaultLocaleForRegion(region) {
    var defaultLang = DEFAULT_LANGUAGE_BY_REGION[region];
    return "".concat(defaultLang, "-").concat(region);
}
function getRegion(locale) {
    return locale.split("-")[1];
}
function getLanguage(locale) {
    return locale.split("-")[0];
}
function getLanguageAndRegion(locale) {
    return locale.split("-");
}
function getLanguageEnglishDisplayName(language) {
    return LANGUAGE_DISPLAY_NAMES[language !== null && language !== void 0 ? language : DEFAULT_LANGUAGE];
}
function isActiveRegion(locale, activeRegions) {
    return activeRegions.includes(getRegion(locale));
}
function isEuRegion(region) {
    return EU_REGIONS.includes(region);
}
function getActiveLocales(activeRegions) {
    return ACTIVE_LOCALES.filter(function(locale) {
        return activeRegions.includes(getRegion(locale));
    });
}
function isLanguageAllowedForRegion(region, lang) {
    var locale = getLocale(region, lang);
    return LOCALES_PER_REGION[region].includes(locale);
}
function isLocaleSupported(locale) {
    return ACTIVE_LOCALES.includes(locale);
}

export { getActiveLocales, getDefaultLocaleForRegion, getLanguage, getLanguageAndRegion, getLanguageEnglishDisplayName, getLocale, getRegion, getRegionForAlias, isActiveRegion, isEuRegion, isLanguageAllowedForRegion, isLocaleSupported };
